import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal, Input, Divider, Select } from "antd";
import usersActions from "../../../redux/users/actions";

const { updateUser } = usersActions;

const AdminUsersEditModal = ({
  user,
  openAdminUserEditModal,
  setOpenAdminUserEditModal,
}) => {
  const { allAccess } = useSelector((state) => state.usersReducer);
  const dispatch = useDispatch();

  const [firstName, setFirstName] = useState(null);
  const [lastName, setLastName] = useState(null);
  const [email, setEmail] = useState(null);
  const [access, setAccess] = useState(null);
  const [organizations, setOrganizations] = useState(null);

  const userId = user?.id;

  useEffect(() => {
    setFirstName(user?.firstName);
    setLastName(user?.lastName);
    setEmail(user?.email);
    setAccess(
      user?.accessInformation === null
        ? []
        : user?.accessInformation?.map((singleAccess) => singleAccess.id)
    );
    setOrganizations(
      user?.organizations
        ?.filter((x) => x.isChecked === true)
        .map((org) => org["id"])
    );
  }, [user, openAdminUserEditModal]);

  const newUserOrganization = user?.organizations?.map(
    ({ isChecked, ...rest }) => {
      if (!organizations?.includes(rest.id)) {
        return { ...rest, isChecked: false };
      } else {
        return { ...rest, isChecked: true };
      }
    }
  );

  const editUser = () => {
    dispatch(
      updateUser({
        id: userId,
        firstName,
        lastName,
        email,
        organizations:
          organizations === null ? user?.organizations : newUserOrganization,
        accessIds: access,
      })
    );
    setOpenAdminUserEditModal(false);
  };

  const closeAdminUserEditModal = () => {
    setOpenAdminUserEditModal(false);
  };

  const userSelectOrganizationsOptions = user?.organizations?.map(
    (organization, index) => {
      return {
        label: organization.name,
        value: organization.id,
        key: index,
      };
    }
  );

  const transformedData = allAccess.map((item, index) => ({
    value: item.id,
    label: item.name,
    key: index,
    disabled: item.name === "Admin" ? true : false,
  }));

  return (
    <Modal
      centered
      width={window.innerWidth > 760 ? "50%" : "95%"}
      open={openAdminUserEditModal}
      onOk={editUser}
      okText="Запази"
      cancelText="Затвори"
      title={`${user?.firstName} ${user?.lastName}${
        user.organizationName ? ` - ${user.organizationName}` : ""
      }`}
      onCancel={closeAdminUserEditModal}
    >
      <div className="admin-users-edit-container">
        <div className="admin-users-edit-input-container">
          <label className="admin-users-edit-input-label">Име</label>
          <Input
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
          />
        </div>
        <div className="admin-users-edit-input-container">
          <label className="admin-users-edit-input-label">Фамилия</label>
          <Input
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
          />
        </div>
      </div>

      <div className="admin-users-edit-container">
        <div className="admin-users-edit-input-container">
          <label className="admin-users-edit-input-label">Имейл</label>
          <Input disabled value={email} />
        </div>
        <div className="admin-users-edit-input-container">
          <label className="admin-users-edit-input-label">Права</label>
          <Select
            listHeight={300}
            mode="multiple"
            options={transformedData}
            value={access}
            onChange={(value) => setAccess(value)}
            filterOption={(input, option) =>
              option.label.toLowerCase().includes(input.toLowerCase())
            }
            className="admin-users-edit-input-container"
          />
        </div>
      </div>

      <div className="admin-users-edit-container">
        <div className="admin-users-edit-input-container">
          <label className="admin-users-edit-input-label">Организации</label>
          <Select
            filterOption={(inputValue, option) =>
              option.label.toLowerCase().includes(inputValue.toLowerCase())
            }
            mode="multiple"
            options={userSelectOrganizationsOptions}
            value={organizations}
            onChange={(value) => setOrganizations(value)}
            className="admin-users-edit-input-container"
          />
        </div>
      </div>

      <Divider />
    </Modal>
  );
};

export default AdminUsersEditModal;
